// ** React Imports
import React, { memo } from 'react';
// ** Redux Imports
import { useSelector } from 'react-redux';
// ** Root Reducer Imports
import { RootState } from '../../../../../../store/root-reducer';
// ** Components Imports
import AiCopilotUserChatCard from './ai-copilot-user-chat-card';
// ** Types Imports
import { AiSeqCopilotUserChat } from '../../type';

/**
 * @description AI Copilot User Chat Card Container
 * @returns => React Component
 */
const AiCopilotUserChatCardContainer: React.FC<{
  chatConversation: AiSeqCopilotUserChat[];
}> = ({ chatConversation = [] }) => {
  const { firstName, lastName } = useSelector(
    (state: RootState) => state?.myProfile?.myProfile,
  );

  return (
    <AiCopilotUserChatCard
      chatConversation={chatConversation}
      firstName={firstName}
      lastName={lastName}
    />
  );
};

export default memo(AiCopilotUserChatCardContainer);
